import { AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { ManInvGroup, ManInvGroupBody, ManInvItem, ManInvRawProd, ManInvRawProds } from './manInv.types';

export const useManInvGroups = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<ManInvGroup[], any>>({
    queryKey: 'manInvGroups',
    queryFn: () => apiClient.get<ManInvGroup[]>('/maninv-groups'),
    enabled,
  });
};

export const useManInvItems = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<ManInvItem[], any>>({
    queryKey: 'maninv',
    queryFn: () => apiClient.get<ManInvItem[]>('/maninv-items'),
    enabled,
  });
};

export const useManInvGroupItems = (id: string | undefined, enabled: boolean = false) => {
  return useQuery<AxiosResponse<ManInvItem[], any>>({
    queryKey: ['maninv', id],
    queryFn: () => apiClient.get<ManInvItem[]>(`/maninv-groups/${id}/items`),
    enabled,
  });
};

export const useManInvRawProds = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<ManInvRawProds[], any>>({
    queryKey: 'manInvRawProds',
    queryFn: () => apiClient.get<ManInvRawProds[]>('/maninv-raw-prods'),
    enabled,
  });
};

export const useAddManInvRawProd = () => {
  return useMutation((manInvItem: ManInvRawProd) => {
    return apiClient.post(`/maninv-items`, manInvItem);
  });
};

export const useAddManInvGroup = () => {
  return useMutation((groups: ManInvGroupBody) => {
    return apiClient.post(`/maninv-groups`, groups);
  });
};

export const useUpdateManInvGroupItems = (id: string) => {
  return useMutation((items: number[]) => {
    return apiClient.put(`/maninv-groups/${id}/items`, items);
  });
};

export const useEditManInvGroup = (id: string|undefined) => {
  return useMutation((groups: ManInvGroupBody) => {
    return apiClient.put(`/maninv-groups/${id}`, groups);
  });
};

export const useDeleteManInvGroup = () => {
  return useMutation((id: string) => {
    return apiClient.delete(`/maninv-groups/${id}`);
  });
};
